import React, { Component } from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {isNumber} from 'utils/IsNumber.js';

class HarmonicsEditor extends Component {
    render() {
        let osc = this.props.oscillator;
        let partials = osc.partials;
        if (!partials) {
            return (
                <div></div>
            );
        }
        return (
            <div className="harmonics-editor">
              Harmonics Editor
              {partials.slice(0,64).map(
                  (p, i) => <PartialEditor oscillator={osc} i={i}/>
              )}
            </div>
        );
    }
}

class PartialEditor extends Component {
    constructor(props) {
        super(props);

        let partial = this.props.oscillator.partials[this.props.i];
        this.state = {
            value: partial
        };
    }

    onChange(value) {
        let partials = [...this.props.oscillator.partials];
        partials[this.props.i] = value;
        this.props.oscillator.partials = partials;
        this.setState(this.state);
    }

    render() {
        let partial = this.props.oscillator.partials[this.props.i];
        return (
            <div className="partial-editor">
              <div className="partial-number">{this.props.i + 1}</div>
              <ReactBootstrapSlider
                value={partial}
                change={(e) => this.onChange(e.target.value)}
                step={0.01}
                max={8}
                min={0}
                orientation="horizontal"
                reversed={false}
                />
            </div>
        );
    }
}

export default HarmonicsEditor;
